import { Link } from 'react-router-dom';
import { ChefHat, Heart, Mail, Instagram, Facebook } from 'lucide-react';

export const Footer = () => {
    return (
        <footer className="bg-foreground text-background mt-auto relative overflow-hidden">
            {/* Colorful top border */}
            <div className="h-2 bg-gradient-cameleon" />
            
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
                    {/* Brand */}
                    <div className="col-span-1 md:col-span-2">
                        <Link to="/" className="flex items-center gap-3 mb-6 group">
                            <div className="p-3 bg-gradient-cameleon rounded-2xl border-2 border-white/20">
                                <ChefHat className="w-8 h-8 text-white" />
                            </div>
                            <div>
                                <span className="font-heading font-black text-2xl block">
                                    Recettes
                                </span>
                                <span className="font-heading font-black text-2xl text-gradient-cameleon -mt-1 block">
                                    Caméléon
                                </span>
                            </div>
                        </Link>
                        <p className="text-white/70 mb-6 max-w-md text-lg leading-relaxed">
                            Découvrez des recettes faciles, économiques et délicieuses. 
                            Économisez sur vos courses tout en régalant votre famille!
                        </p>
                        <div className="flex items-center gap-2 text-white">
                            <span className="font-medium">Fait avec</span>
                            <Heart className="w-5 h-5 text-pink-400 fill-current animate-pulse" />
                            <span className="font-medium">pour votre portefeuille</span>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="font-heading font-black text-xl mb-6 text-white">Navigation</h4>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/recipes" className="text-white/70 hover:text-green-400 transition-colors font-medium flex items-center gap-2 group">
                                    <span className="w-2 h-2 bg-green-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
                                    Toutes les recettes
                                </Link>
                            </li>
                            <li>
                                <Link to="/tips" className="text-white/70 hover:text-orange-400 transition-colors font-medium flex items-center gap-2 group">
                                    <span className="w-2 h-2 bg-orange-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
                                    Astuces économiques
                                </Link>
                            </li>
                            <li>
                                <Link to="/weekly-pack" className="text-white/70 hover:text-purple-400 transition-colors font-medium flex items-center gap-2 group">
                                    <span className="w-2 h-2 bg-purple-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
                                    Pack Hebdomadaire
                                </Link>
                            </li>
                            <li>
                                <Link to="/subscription" className="text-white/70 hover:text-pink-400 transition-colors font-medium flex items-center gap-2 group">
                                    <span className="w-2 h-2 bg-pink-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
                                    Devenir Premium
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Categories */}
                    <div>
                        <h4 className="font-heading font-black text-xl mb-6 text-white">Catégories</h4>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/recipes?category=breakfast" className="text-white/70 hover:text-cyan-400 transition-colors font-medium">
                                    Déjeuner
                                </Link>
                            </li>
                            <li>
                                <Link to="/recipes?category=lunch" className="text-white/70 hover:text-green-400 transition-colors font-medium">
                                    Dîner
                                </Link>
                            </li>
                            <li>
                                <Link to="/recipes?category=dinner" className="text-white/70 hover:text-orange-400 transition-colors font-medium">
                                    Souper
                                </Link>
                            </li>
                            <li>
                                <Link to="/recipes?category=dessert" className="text-white/70 hover:text-purple-400 transition-colors font-medium">
                                    Desserts
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
                    <p className="text-white/50 text-sm font-medium">
                        © {new Date().getFullYear()} Recettes Caméléon. Tous droits réservés.
                    </p>
                    <div className="flex items-center gap-3">
                        <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-pink-500 flex items-center justify-center transition-all hover:-translate-y-1">
                            <Instagram className="w-5 h-5 text-white" />
                        </a>
                        <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-blue-500 flex items-center justify-center transition-all hover:-translate-y-1">
                            <Facebook className="w-5 h-5 text-white" />
                        </a>
                        <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-green-500 flex items-center justify-center transition-all hover:-translate-y-1">
                            <Mail className="w-5 h-5 text-white" />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
